
import { z } from 'zod'

export const imageSchema = (message: string) =>
  z.custom<File>((file) => {
    return (
      file instanceof File &&
      // jpg|jpeg|png|gif|bmp
      [
        'image/jpg',
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/bmp'
      ].includes(file.type) &&
      file.size <= 4 * 1024 * 1024
    ) // 4MB
  }, message)
